import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardPanel from '../DashboardPanel';
import { bookingApi } from '../../utils/bookingApi';
import { useFeature } from '../../hooks/useFeature';
import { legacyName } from '../../utils/sessionTypes';
import { formatDayDate } from '../../utils/dates';

const typeLabel = (types) => types.map(legacyName).join(' + ');
const localDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// "Today", "Tomorrow" or "Tue 28 Oct 2026"
export function dayLabel(iso, now = new Date()) {
  const day = iso.slice(0, 10);
  if (day === localDay(now)) return 'Today';
  if (day === localDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1))) return 'Tomorrow';
  return formatDayDate(`${day}T12:00:00Z`);
}

// Staff home, with Session coaches: the next session this coach is on (in
// the next two weeks), opening its register. Nothing when they're on none.
export default function MySessionsCard() {
  const on = useFeature('sessionCoaches');
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    if (!on) return;
    bookingApi.getMySessions(14).then(r => setSessions(r.data)).catch(() => setSessions([]));
  }, [on]);

  if (!on || !sessions?.length) return null;
  const s = sessions[0];
  return (
    <DashboardPanel
      className="dashboard-comp"
      headerClassName="dashboard-comp__header"
      title={<span className="dashboard-comp__title">My next session</span>}
    >
      <ul className="dashboard-comp__list">
        <Link to={`/booking/admin/register/${s.id}`} className="dashboard-comp__item">
          <div className="dashboard-comp__item-main">
            <div className="dashboard-comp__item-name">{dayLabel(s.date)}, {s.startTime} to {s.endTime}</div>
            <div className="dashboard-comp__item-meta">{typeLabel(s.types)}</div>
          </div>
          <span className="dashboard-comp__cta">Register</span>
        </Link>
      </ul>
    </DashboardPanel>
  );
}
